<template>
    <div class="map">
        <DrawBase
            ref="drawMap"
            :center="mapCenter"
            :zoom="9"
            @on-mounted="initMap"
            @on-map-click="clickMap"
        />
        <StatusFlag class="filter-status" @change="changeStatus" />
        <MapOption />
        <el-dialog
            title="作业图片"
            :visible.sync="popup.jobPictureShow"
            center
            @closed="closeReset"
        >
            <div class="condition">
                <div class="condition__group">
                    <div class="condition__group--plate">
                        <span>车牌号：</span>
                        <span>{{ popup.params.plateNumber }}</span>
                    </div>
                    <div class="condition__group-default--date">
                        <span>日期筛选：</span>
                        <el-date-picker
                            v-model="pictureDate"
                            :pickerOptions="pickerOptions"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请选择日期"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <el-button
                    @click="handleJobPicture"
                    type="primary"
                    class="condition--query"
                    >查询</el-button
                >
            </div>
            <el-carousel
                trigger="click"
                :autoplay="false"
                @change="jobPictureChange"
                arrow="always"
                class="popup__body"
            >
                <template v-if="popup.jobPictureData.length">
                    <el-carousel-item
                        v-for="(item, index) in popup.jobPictureData"
                        :key="`task-${index}`"
                        class="popup__body--item"
                    >
                        <!-- 第三方返回时时间后面多了个 .0，截取掉 -->
                        <span>{{ item.time.split('.0')[0] }}</span>
                        <img :src="item.photoUrl" />
                    </el-carousel-item>
                </template>
                <p v-else class="popup__body--empty">
                    暂无数据
                </p>
            </el-carousel>
            <div class="job-picture__length">
                <span>{{ popup.jobPictureCurrIndex }}</span>
                <span> / {{ popup.jobPictureData.length }}</span>
            </div>
        </el-dialog>
        <el-dialog
            title="历史轨迹"
            :visible.sync="popup.trajectoryShow"
            center
            @closed="closeReset"
        >
            <div class="condition">
                <div class="condition__group">
                    <div class="condition__group--plate">
                        <span>车牌号：</span>
                        <span>{{ popup.params.plateNumber }}</span>
                    </div>
                    <div class="condition__group-default--date">
                        <span>日期筛选：</span>
                        <el-date-picker
                            v-model="trajectoryDate"
                            :pickerOptions="pickerOptions"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请选择日期"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <el-button
                    @click="handleTrajectory"
                    type="primary"
                    class="condition--query"
                    >查询</el-button
                >
            </div>
            <DrawBase
                :center="trajectoryCenter"
                :zoom="16"
                :graphicInfoList="popup.trajectoryData"
                class="popup__body"
            />
        </el-dialog>
        <el-dialog
            title="作业查询"
            :visible.sync="popup.jobQueryShow"
            center
            @closed="closeReset"
        >
            <div class="condition">
                <div class="condition__group">
                    <div class="condition__group--plate">
                        <span>车牌号：</span>
                        <span>{{ popup.params.plateNumber }}</span>
                    </div>
                    <el-date-picker
                        v-model="queryDate"
                        :editable="false"
                        :picker-options="pickerQueryOptions"
                        @change="onChangeQueryDate"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        class="condition__group-default--date"
                    ></el-date-picker>
                </div>
                <el-button
                    @click="handleQuery"
                    type="primary"
                    class="condition--query"
                    >查询</el-button
                >
            </div>
            <el-table :data="popup.jobQueryData" border class="popup__body">
                <el-table-column prop="address" label="作业地点">
                </el-table-column>
                <el-table-column prop="jobType" label="作业类型">
                </el-table-column>
                <el-table-column prop="machineType" label="农机类型">
                </el-table-column>
                <el-table-column prop="jobArea" label="作业面积（亩）">
                </el-table-column>
                <el-table-column prop="averDeep" label="作业深度（厘米）">
                </el-table-column>
                <el-table-column prop="startEndTime" label="作业时间">
                </el-table-column>
                <el-table-column prop="datsSource" label="数据来源平台">
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="popup.jobQueryData.length"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="popup.currentPage"
                :page-sizes="popup.pageSizes"
                :page-size="popup.pageSize"
                layout="prev, pager, next, total, sizes, jumper"
                :total="popup.total"
            >
            </el-pagination>
        </el-dialog>
    </div>
</template>
<script>
import DrawBase from '@/components/DrawBase'
import MapOption from './components/MapOption.vue'
import StatusFlag from './components/StatusFlag.vue'
import L from '@tuliu/leaflet'
import eventHub from '@/utils/eventHub'
import env from '@/config/env'
import * as largeScreenAPI from '@/api/large-screen'
import Socket, { uri, MACHINEPOINT } from '@/socket/index'
import { formatDate, getBeforeDate } from '@/utils/index'
import {
    lngLatListToLatLngList,
    calculateCenter,
    getGeocodeInfo
} from '@tuliu/base-map'
import TractorOnlineIcon from '@/assets/images/on-car.png'
import TractorOfflineIcon from '@/assets/images/off-car.png'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster/dist/leaflet.markercluster-src.js'

export default {
    components: {
        DrawBase,
        MapOption,
        StatusFlag
    },
    data() {
        return {
            mapCenter: [48.73434746467879108, 126.63450021565670056],
            currScreenType: {},
            boundary: null,
            mapIns: null,
            markers: null,
            pictureDate: formatDate(new Date(), { type: 'date' }),
            trajectoryDate: formatDate(new Date(), { type: 'date' }),
            trajectoryCenter: [48.73434746467879108, 126.63450021565670056],
            queryDate: [
                getBeforeDate(29, formatDate(new Date(), { type: 'date' })),
                formatDate(new Date(), { type: 'date' })
            ],
            pickerOptions: {
                disabledDate(time) {
                    return (
                        time.getTime() > Date.now() ||
                        time.getTime() < new Date('2021-01-01') - 8.64e7
                    )
                }
            },
            selectDate: '',
            pickerQueryOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate = minDate.getTime()
                    if (maxDate) {
                        this.selectDate = ''
                    }
                },
                disabledDate: (time) => {
                    var isSelected = false
                    if (this.selectDate !== '') {
                        const minTime = this.selectDate - 30 * 24 * 3600 * 1000
                        const maxTime =
                            this.selectDate + (30 - 1) * 24 * 3600 * 1000
                        isSelected =
                            time.getTime() <= minTime ||
                            time.getTime() > maxTime
                    }
                    return (
                        isSelected ||
                        time.getTime() > Date.now() - 8.64e6 ||
                        time.getTime() < new Date('2021-01-01') - 8.64e7
                    )
                }
            },
            popup: {
                // 公共参数
                params: {},
                // 作业图片
                jobPictureShow: false,
                jobPictureData: [],
                jobPictureCurrIndex: 1,
                // 历史轨迹
                trajectoryShow: false,
                trajectoryData: [],
                // 作业查询
                jobQueryShow: false,
                jobQueryData: [],
                jobBeginTime: getBeforeDate(
                    29,
                    formatDate(new Date(), { type: 'date' })
                ),
                jobEndTime: formatDate(new Date(), { type: 'date' }),
                total: 0,
                pageSizes: [20, 50, 80, 100],
                pageSize: 20,
                currentPage: 1
            },
            isPopup: false,
            mapOnlinePoints: [],
            mapOfflinePoints: []
        }
    },
    methods: {
        initMap(baseMap) {
            this.mapIns = baseMap.mapInstance

            this.currScreenType = JSON.parse(
                sessionStorage.getItem('currScreenType')
            )

            this.mapCenter = this.currScreenType.center

            this.trajectoryCenter = this.currScreenType.center

            this.boundary = require(`@/utils/${this.currScreenType.locId}-boundary.json`)
            // 绘制圈选边界
            this.$refs.drawMap.geoFCJson(this.boundary)

            // 获取地图标点
            this.getPoint()
        },
        createInfoPopup(data) {
            this.popup.params.terminalCode = data.terminalCode
            this.popup.params.plateNumber = data.plateNumber

            const html = `<ul class="popup__container"><li class="point--title">终端信息</li><li class="point--option"><span>所属合作社：</span><span>${data.cooperativeName ||
                '无'}</span></li><li class="point--option"><span>车牌号码：</span><span>${
                data.plateNumber
            }</span></li><li class="point--option"><span>终端编号：</span><span>${
                data.terminalCode
            }</span></li><li class="point--option"><span>设备时间：</span><span>${data.deviceTime ||
                '无'}</span></li><li class="point--option"><span>农机主：</span><span>${
                data.ownerName
            }/${
                data.ownerPhone
            }</span></li><li class="point--option"><span>经纬度：</span><span>${
                data.lng
            }，${
                data.lat
            }</span></li><li class="point--option"><span>地址：</span><span>${
                data.pointAddress
            }</span></li><li class="point--option"><span>农机类型：</span><span>${
                data.machineType
            }</span></li><li class="point--option"><span>作业类型：</span><span>${
                data.jobType
            }</span></li><li class="point--option"><span>农机状态：</span><span>${
                !+data.onlineStatus ? '离线' : '在线'
            }</span></li><li class="point--option"><span>深度：</span><span>${
                !data.averDeep ? '无' : data.averDeep + '厘米'
            }</span></li><li class="point--option"><span>作业宽幅：</span><span>${
                !data.toolWidth ? '无' : data.toolWidth + '米'
            }</span></li></ul><div class="btn__group"><button
                onclick="handleToJobPicture()"
                type="primary"
                >作业图片</button
            ><button
                onclick="handleToTrajectory()"
                type="primary"
                >历史轨迹</button
            ><button
                onclick="handleToJobQuery()"
                type="primary"
                >作业查询</button
            ></div>`
            return html
        },
        changeStatus(val) {
            if (val == 1) {
                this.createMakers(this.mapOnlinePoints)
            } else if (val == 2) {
                this.createMakers(this.mapOfflinePoints)
            } else if (val == 0) {
                this.createMakers([
                    ...this.mapOfflinePoints,
                    ...this.mapOnlinePoints
                ])
            }
        },
        createMakers(data) {
            if (!this.mapIns) return false
            this.markers && this.mapIns.removeLayer(this.markers)

            const machineOnlineIcon = L.icon({
                iconUrl: TractorOnlineIcon,
                iconSize: [37, 43],
                iconAnchor: [23, 46]
            })
            const machineOfflineIcon = L.icon({
                iconUrl: TractorOfflineIcon,
                iconSize: [37, 43],
                iconAnchor: [23, 46]
            })

            this.markers = L.markerClusterGroup({
                spiderfyOnMaxZoom: true,
                showCoverageOnHover: false,
                zoomToBoundsOnClick: true
            })

            data.forEach((item) => {
                if (item.lat && item.lng) {
                    const marker = L.marker(
                        new L.LatLng(+item.lat, +item.lng),
                        {
                            icon:
                                item.onlineStatus === '1'
                                    ? machineOnlineIcon
                                    : machineOfflineIcon
                        }
                    )
                    marker
                        .bindPopup()
                        .on(
                            'click',
                            async ({ target, latlng: { lat, lng } }) => {
                                const markerPopup = target.getPopup()
                                this.isPopup = markerPopup.isOpen()
                                const response = await largeScreenAPI.getPointDetails(
                                    item.terminalCode
                                )
                                if (response && response.data) {
                                    this.mapCenter = [lat, lng]
                                    const geo = await getGeocodeInfo(
                                        [lat, lng],
                                        env.CEMUYI_TIANDITU_KEY
                                    )
                                    response.data.pointAddress =
                                        geo.formatted_address
                                    markerPopup.setContent(
                                        this.createInfoPopup(response.data)
                                    )
                                    markerPopup.update()
                                }
                            }
                        )
                    this.markers.addLayer(marker)
                }
            })

            this.mapIns.addLayer(this.markers)
        },
        clickMap() {
            this.isPopup = false
        },
        async getPoint() {
            const response = await largeScreenAPI.getPoint(
                this.currScreenType.locId
            )
            if (response && response.data && response.data.length) {
                this.createMakers(response.data)
                response.data.forEach((item) => {
                    if (item.onlineStatus == 1) {
                        this.mapOnlinePoints.push(item)
                    } else {
                        this.mapOfflinePoints.push(item)
                    }
                })
            }
        },
        closeReset() {
            this.pictureDate = formatDate(new Date(), { type: 'date' })
            this.trajectoryDate = formatDate(new Date(), { type: 'date' })
            this.queryDate = [
                getBeforeDate(29, formatDate(new Date(), { type: 'date' })),
                formatDate(new Date(), { type: 'date' })
            ]
            this.popup.jobBeginTime = getBeforeDate(
                29,
                formatDate(new Date(), { type: 'date' })
            )
            this.popup.jobEndTime = formatDate(new Date(), { type: 'date' })
        },
        jobPictureChange(index) {
            this.popup.jobPictureCurrIndex = index + 1
        },
        async handleToJobPicture() {
            const dateRes = await largeScreenAPI.getValidDate({
                dataType: 3,
                terminalCode: this.popup.params.terminalCode
            })
            if (dateRes && dateRes.data) {
                this.pictureDate = dateRes.data
            }
            this.handleJobPicture()
        },
        async handleJobPicture() {
            if (!this.pictureDate)
                return this.$message({
                    message: '日期筛选不能为空！',
                    type: 'warning'
                })
            const params = {
                date: this.pictureDate,
                terminalCode: this.popup.params.terminalCode
            }
            const response = await largeScreenAPI.getJobPictures(params)
            if (response) {
                this.popup.jobPictureData = []
                this.popup.jobPictureShow = true
                if (response.data && response.data.length) {
                    this.popup.jobPictureData = response.data
                    this.popup.jobPictureCurrIndex = 1
                } else {
                    this.popup.jobPictureData = []
                    this.popup.jobPictureCurrIndex = 0
                    this.$message({
                        message: '当前日期无数据！',
                        type: 'warning'
                    })
                }
            }
        },
        async handleToTrajectory() {
            const dateRes = await largeScreenAPI.getValidDate({
                dataType: 2,
                terminalCode: this.popup.params.terminalCode
            })
            if (dateRes && dateRes.data) {
                this.trajectoryDate = dateRes.data
            }
            this.handleTrajectory()
        },
        async handleTrajectory() {
            if (!this.trajectoryDate)
                return this.$message({
                    message: '日期筛选不能为空！',
                    type: 'warning'
                })
            const params = {
                date: this.trajectoryDate,
                terminalCode: this.popup.params.terminalCode
            }
            const response = await largeScreenAPI.getTrajectory(params)
            if (response) {
                this.popup.trajectoryData = []
                this.popup.trajectoryShow = true
                if (response.data && response.data.length) {
                    const path = response.data.map((item) => {
                        return [item.lng, item.lat]
                    })
                    const center = calculateCenter(path)
                    this.trajectoryCenter = lngLatListToLatLngList([center])[0]
                    if (path.length <= 2) {
                        this.popup.trajectoryData.push(
                            {
                                path: lngLatListToLatLngList(path),
                                isClosed: false,
                                id: 3,
                                themeColor: '#FF5469',
                                polylineOptions: {
                                    weight: 2
                                }
                            },
                            {
                                path: lngLatListToLatLngList([path[0]]),
                                isClosed: true,
                                id: 0,
                                title:
                                    '<img src="/images/on-car.png" class="icon" />'
                            }
                        )
                    } else {
                        this.popup.trajectoryData.push(
                            {
                                path: lngLatListToLatLngList([path[0]]),
                                isClosed: false,
                                id: 1,
                                polylineOptions: {
                                    weight: 2
                                }
                            },
                            {
                                path: lngLatListToLatLngList(
                                    path.slice(1, path.length - 1)
                                ),
                                isClosed: true,
                                id: 2,
                                themeColor: '#FF5469',
                                polylineOptions: {
                                    weight: 2
                                }
                            },
                            {
                                path: lngLatListToLatLngList([
                                    path[path.length - 1]
                                ]),
                                isClosed: false,
                                id: 3,
                                themeColor: '#FF5469',
                                polylineOptions: {
                                    weight: 2
                                }
                            },
                            {
                                path: lngLatListToLatLngList([path[0]]),
                                isClosed: true,
                                id: 0,
                                title:
                                    '<img src="/images/on-car.png" class="icon" />'
                            }
                        )
                    }
                } else {
                    this.popup.trajectoryData = []
                    this.$message({
                        message: '当前日期无数据！',
                        type: 'warning'
                    })
                }
            }
        },
        async handleToJobQuery() {
            const dateRes = await largeScreenAPI.getValidDate({
                dataType: 1,
                terminalCode: this.popup.params.terminalCode
            })
            if (dateRes && dateRes.data) {
                this.queryDate = [getBeforeDate(29, dateRes.data), dateRes.data]
            }
            this.handleJobQuery()
        },
        async handleJobQuery() {
            this.popup.jobBeginTime = this.queryDate ? this.queryDate[0] : ''
            this.popup.jobEndTime = this.queryDate ? this.queryDate[1] : ''

            const params = {
                page: this.popup.currentPage,
                size: this.popup.pageSize,
                jobBeginTime: this.popup.jobBeginTime,
                jobEndTime: this.popup.jobEndTime,
                terminalCode: this.popup.params.terminalCode
            }
            const response = await largeScreenAPI.getJobQuery(params)
            if (response) {
                this.popup.jobQueryData = []
                this.popup.jobQueryShow = true
                if (response.data && response.data.list.length) {
                    this.popup.total = response.data.total
                    this.popup.jobQueryData = response.data.list
                    this.popup.jobQueryData.forEach((item) => {
                        item.startEndTime = `${item.jobStartTime}/${item.jobEndTime}`
                    })
                } else {
                    this.popup.jobQueryData = []
                    this.$message({
                        message: '当前时间段无数据！',
                        type: 'warning'
                    })
                }
            }
        },
        handleSizeChange(pageSize) {
            this.popup.pageSize = pageSize
            this.popup.currentPage = 1

            this.handleJobQuery()
        },
        handleCurrentChange(page) {
            this.popup.currentPage = page

            this.handleJobQuery()
        },
        handleQuery() {
            this.popup.currentPage = 1
            this.handleJobQuery()
        },
        onChangeQueryDate(date) {
            this.popup.jobBeginTime = date ? date[0] : undefined
            this.popup.jobEndTime = date ? date[1] : undefined
        }
    },
    mounted() {
        // 初始化 socket
        Socket.inits(uri)

        // 接收 socket 地图标点信息
        eventHub.$on(MACHINEPOINT, (data) => {
            setTimeout(() => {
                if (this.isPopup) {
                    this.$notify.info({
                        title: '实时消息通知',
                        message: '农机位置发生变更，请重新查看！'
                    })
                }
                this.createMakers(data)
                this.isPopup = false
            }, 100)
        })

        // 模板字符串绑定事件
        window.handleToJobPicture = this.handleToJobPicture
        window.handleToTrajectory = this.handleToTrajectory
        window.handleToJobQuery = this.handleToJobQuery
    },
    destroyed() {
        Socket.destroy()

        eventHub.$off(MACHINEPOINT)
    }
}
</script>
<style lang="scss" scoped>
.map {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 21px 0 0 0 !important;
    ::v-deep {
        .map-container {
            .leaflet-marker-icon {
                > div {
                    > span {
                        color: #fff;
                    }
                }
            }
        }
        .leaflet-popup {
            top: -5px;
            width: 304px;
            margin-bottom: 0;
            .leaflet-popup-tip-container,
            .leaflet-popup-close-button {
                display: none;
            }
            .leaflet-popup-content-wrapper {
                background: none;
                box-shadow: none;
                width: 100%;
                box-sizing: border-box;
                background: rgba(30, 31, 46, 0.8);
                border: 0.5px solid rgba(15, 128, 252, 0.22);
                box-shadow: 0 0 8px 2px rgba(0, 57, 119, 0.5);
                .leaflet-popup-content {
                    width: 100% !important;
                    margin: 0;
                    .popup__container {
                        width: 100%;
                        margin: 0;
                        padding: 10px 15px;
                        font-size: 14px;
                        color: #ffffff;
                        line-height: 26px;
                        box-sizing: border-box;
                        .point--title {
                            margin: 0 0 4px 0;
                            text-align: center;
                            font-size: 16px;
                            font-weight: 600;
                        }
                        .point--option {
                            word-break: break-all;
                            text-align: justify;
                        }
                    }
                    .btn__group {
                        display: flex;
                        justify-content: space-between;
                        padding: 0 10px 15px 10px;
                        button {
                            height: 26px;
                            line-height: 24px;
                            color: #fff;
                            background-color: #409eff;
                            border-radius: 4px;
                            font-size: 16px;
                            flex-grow: 1;
                            margin: 0 5px;
                            outline: none;
                            border: none;
                            cursor: pointer;
                            transition: background-color 0.1s;
                            &:hover {
                                background-color: #66b1ff;
                            }
                            &:active {
                                background-color: #3a8ee6;
                            }
                        }
                    }
                }
            }
        }
        .condition {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            .condition__group {
                display: flex;
                align-items: center;
                &--plate {
                    margin-right: 36px;
                    font-size: 16px;
                    color: #999;
                    span {
                        &:first-child {
                            position: relative;
                            top: 2px;
                        }
                        &:last-child {
                            display: inline-block;
                            width: 180px;
                            height: 38px;
                            line-height: 34px;
                            border: 1px solid #dcdfe6;
                            background: #f6f6f6;
                            border-radius: 4px;
                            padding-left: 12px;
                            box-sizing: border-box;
                            cursor: default;
                        }
                    }
                }
                &-default--date {
                    font-size: 16px;
                    color: #333;
                    .el-range-input,
                    .el-range-separator {
                        color: #333;
                    }
                    .el-date-editor {
                        width: 180px;
                        .el-input__prefix {
                            left: 12px;
                        }
                        .el-input__inner {
                            padding-left: 38px;
                        }
                    }
                }
            }
            .condition--query {
                width: 134px;
                text-align: center;
            }
        }
        .job-picture__length {
            margin-top: 20px;
            text-align: center;
            span {
                font-size: 22px;
                &:first-child {
                    color: #429afa;
                }
                &:last-child {
                    color: #333;
                }
            }
        }
        .popup__body {
            height: 534px;
            ::-webkit-scrollbar {
                width: 9px;
                height: 9px;
            }
            ::-webkit-scrollbar-track {
                background: rgba(0, 0, 0, 0);
                border-radius: 4px;
            }
            ::-webkit-scrollbar-thumb {
                background-color: #94a2b4;
                border-radius: 4px;
            }
            .leaflet-vertex-icon::after {
                background-color: #d9021c;
            }
            .el-carousel__container {
                height: 100%;
                .popup__body--empty {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    margin: 0;
                    font-size: 20px;
                    color: #888;
                }
            }
            .el-carousel__indicators {
                display: none;
            }
            &--item {
                width: 100%;
                text-align: center;
                > span {
                    position: absolute;
                    bottom: 20px;
                    right: calc(50% - 107px);
                    width: 214px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.9);
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
                    font-weight: 600;
                }
                > img {
                    height: 100%;
                }
            }
        }
        .el-pagination {
            margin: 10px 0;
            text-align: center;
        }
    }
}
</style>
